export const trustpilotHorizontalWrapperStyles = {
  pb: ['md', 'xxl'],
  border: 'none',
  borderBottom: ({ colors = {} }) => `1px solid ${colors['grey-20']}`,
  '& .trustpilot-widget': {
    margin: 0
  }
}
